import queryString from 'query-string';
import React from 'react';
import axios from '../Api/MainApi';
import Article from '../Components/Article';
import Editor from '../Components/Editor';
import Search from '../Components/Search';
import SideBar from '../Components/SideBar';
import methodsOneContext from '../Contexts/MethodsOne';
import MethodsTwoContext from '../Contexts/MethodsTwo';
import logger from '../Tools/Log';
import './../App.css';
import LoadingOverlay from 'react-loading-overlay';


export default class App extends React.Component {
  constructor(props) {
    super(props);

    logger('Route>>Remember>>constructor>>this.props.match.params.id>>', this.props.match.params.id);
    this.state = {
      detailList: [],
      editId: this.props.match.params.id > 0 ? this.props.match.params.id : -1,
      pageMode:''
    }

  }

  state = {
    loading:false,
    detailList: [],
    editId: -1,
    pageMode:''
  }
  static contextType = MethodsTwoContext;

  componentDidMount() {
    const { location: { search } } = this.props;
    const values = queryString.parse(search);
    if (values.search != undefined) {
      this.searchHandler(values.search);
    }
  }

  setDetailList(data) {
    logger('Route>>Remember>>setDetailList>>', data);
    this.setState(prevState => {
      return {
        detailList: data,
        editId: -1,
        pageMode:''
      }
    })

  }

  loading(){
    if(this.state.loading)
       this.setState({loading:false}); 
       else
       this.setState({loading:true}); 
  }

  searchHandler(text) {
    logger('Route>>Remember>>Axios{rest/search/}>>', text);
    this.loading();  
    axios.get(`rest/search/${text}`, {
      headers: {
        Authorization: this.context.authorizationInfo.state.accessToken
      },

    })
      .then(Response => {
        this.loading();  
        this.setDetailList(Response.data)
      })
      .catch(err => {
        this.loading();  
        console.log(err)
      })
  }

  editDetail(id) {
    logger('Route>>Remember>>editDetail>>', id);
    this.setState(prevState => {
      return {
        editId: id
      }
    })
  }

  editUrl(text) {
    if (!this.props.history.location.pathname.includes("Edit")) {
      this.props.history.push(text)
    }

  }

  newEvent() {

    this.setState(prevState => {
      return {
        detailList: [{ id: 0, description: '', tag: '' }],
        editId: 0,
        pageMode:'new'
      }
    })

    logger('Route>>Remember>>newEvent>>state>>', this.state);

  }


  render() {

    logger('Route>>Remember>>render');
    let detailList = this.state.detailList;
    let editId = this.state.editId;
    return (

      <>
      <LoadingOverlay
                active={this.state.loading}
                spinner
                text='لطفا صبور باشید...'
                >
        <methodsOneContext.Provider value={{
          methodsOneState: this.state.DetailList,
          setDetailList: this.setDetailList.bind(this),
          editDetail: this.editDetail.bind(this),
          editUrl: this.editUrl.bind(this),
          searchHandler: this.searchHandler.bind(this),
          loading: this.loading.bind(this),
        }}>



          {/* <BlueTicket/> */}


          <div class="co-padding discuss_bg">
            <div class="subject container">
              <div class="subject_main discuss-main reply-main">
                <div class="subject_content"><div class="create-discuss">

                  <div class="buttonContainer">


                    <Search />
                    <div class="search-box_discuss"  ><form action="" autoComplete="off">
                      <div class="search-box" style={{ height: 48, width: 120 }}>

                        <button onClick={this.newEvent.bind(this)} type="button">مورد جدید</button></div></form>  </div>

                  </div>






                  {
                    editId >= 0
                      ? (<></>)
                      :
                      (
                        detailList.length === 0
                          ? <></>
                          :

                          detailList.map(item => {
                            return (
                              <section class="discuss-list">
                                <Article
                                  key={item.id}
                                  item={item}
                                />
                              </section>
                            )
                          })

                      )
                  }




                </div>
                  <div class="reply-list">
                    {
                      editId > 0
                        ? (<Editor item={{ id: editId }} />)
                        :
                        (
                          editId == 0
                            ?
                            (<Editor item={{pageMode: this.state.pageMode}} />)
                            :
                            (<></>)
                        )
                    }

                  </div>
                </div>





                <div class="subject_sidebar">
                  <div class="create-discuss">
                    <a href="/discuss/create">ایجاد بحث و گفتگو</a>
                  </div>
                  <SideBar />
                  <div class="introduction-box courses">
                    <div class="img">
                      <img src={require('./../img/learn-code.png')} alt="آموزش برنامه&zwnj;نویسی" />
                    </div>
                    <div class="description">
                      <a href="/series">
                        <h3 class="title">آموزش برنامه&zwnj;نویسی</h3>
                        <p class="paragraph">اگر به دنبال یادگیری برنامه&zwnj;نویسی و طراحی&zwnj;وب هستید، ما در بیت کالا آموزش&zwnj;های مختلفی را برایتان آماده کرده&zwnj;ایم که می&zwnj;توانید از آن&zwnj;ها بهره ببرید.</p></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>



        </methodsOneContext.Provider>
        </LoadingOverlay>
      </>
    )
  }
}


